<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Drop Off</h5>
            </template>

            <b-row class="mb-3">
                <b-col cols="12" md="6">
                    <b-form-group label="Cabang Tujuan">
                        <multiselect
                            name="filterCabangTujuan"
                            v-model="input.filterCabangTujuan"
                            :options="cabangOptions"
                            :internal-search="true"
                            :allow-empty="false"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Status">
                        <b-form-select v-model="input.filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null">-- Semua Status --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="12" lg="6">
                    <b-form-group label="Tanggal">
                        <div class="d-flex" :class="isMobile ? 'flex-wrap' : ''">
                            <b-form-input
                                v-model="input.filterTanggalMulai" name="filterFromDate"
                                id="filterTanggal"
                                type="date"
                                class="flex-fill"
                            ></b-form-input>
                            <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                            <b-form-input
                                v-model="input.filterTanggalAkhir" name="filterToDate"
                                type="date"
                                class="flex-fill"
                            ></b-form-input>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter">
                        <i class="fa fa-search"></i>
                    </b-button>
                    <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                </b-col>
            </b-row>

            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="dataDropOff"
                :fields="isMobile ? fieldsMobile : fieldsDesktop"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Belum ada drop off yang masuk ke cabang ini.
                </template>
                <template v-if="isMobile" v-slot:cell(detail)="row">
                    <div class="smallText font-weight-bold">Total {{ row.item.duses.length }} Dus / Food Container</div>
                    <div class="smallText text-muted" v-for="dus in row.item.duses" :key="dus.sourceDusId">
                        {{ dus.dusType }} &middot; {{ dus.rincianBarang }} (Total: {{ dus.jumlahBarang }})
                    </div>
                    <small class="d-block mt-1">{{ $helper.changeDateFormat(row.item.tanggal) }} {{ $helper.changeDateFormatGetHour(row.item.tanggal) }}</small>
                    <small class="d-block">Dikirim Oleh: {{ row.item.pengirimStaffNama }}</small>
                    <small class="d-block">Titik Drop Off: {{ row.item.isCabangSendiri ? 'Cabang Sendiri' : 'Titip Cabang Lain' }}</small>
                    <small class="d-block">Metode Pengiriman: {{ row.item.deliveryChannelNama }}</small>
                    <small class="d-block">Cabang Pengirim: {{ row.item.cabangPengirimNama }}</small>
                    <small class="d-block">Cabang Tujuan: {{ row.item.cabangTujuanNama }}</small>
                    <div class="mt-1">
                        <b-badge variant="warning" v-if="row.item.status == SHIPMENT_STATUS.PENGIRIMAN_KE_DROPOFF">Dalam Pengiriman</b-badge>
                        <b-badge variant="success" v-else>Diterima</b-badge>
                    </div>
                </template>
                <template v-slot:cell(noPengiriman)="row">
                    <div class="smallText font-weight-bold">Total {{ row.item.duses.length }} Dus / Food Container</div>
                    <div class="smallText text-muted" v-for="dus in row.item.duses" :key="dus.sourceDusId">
                        {{ dus.dusType }} &middot; {{ dus.rincianBarang }} (Total: {{ dus.jumlahBarang }})
                    </div>
                </template>
                <template v-slot:cell(tanggal)="row">
                    <div class="no-wrap">
                        {{ $helper.changeDateFormat(row.item.tanggal) }}
                        {{ $helper.changeDateFormatGetHour(row.item.tanggal) }}
                    </div>
                    <div class="smallText text-muted no-wrap">{{ row.item.pengirimStaffNama }}</div>
                </template>
                <template v-slot:cell(metodePengiriman)="row">
                    <div class="no-wrap">Titik Drop Off: {{ row.item.isCabangSendiri ? 'Cabang Sendiri' : 'Titip Cabang Lain' }}</div>
                    <div class="smallText text-muted no-wrap">Metode Pengiriman: {{ row.item.deliveryChannelNama }}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status == SHIPMENT_STATUS.PENGIRIMAN_KE_DROPOFF">Dalam Pengiriman</b-badge>
                    <b-badge variant="success" v-else>Diterima</b-badge>
                </template>
                <template v-slot:cell(aksi)="row">
                    <div class="no-wrap">
                        <b-button v-if="canTerima(row.item)" size="sm" variant="success" v-b-tooltip.hover.top title="Terima" @click="openModalTerima(row.item.id)">
                            <i class="fa fa-check"></i>
                        </b-button>
                        <b-button v-if="canTolak(row.item)" size="sm" class="ml-2" variant="outline-danger" v-b-tooltip.hover.top title="Tolak" @click="openModalTolak(row.item.id)">
                            <i class="fa fa-times"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>

        <ModalConfirm id="modal-confirm-terima-dropoff" title="Konfirmasi Terima" :isSubmitting="isSubmitting" desc="Apakah anda yakin sudah menerima dus ini secara fisik?" @submit="onTerima" />

        <b-modal id="modal-tolak-dropoff" title="Tolak Drop Off" centered :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting">
            <b-form id="tolakDropOffForm" @submit.prevent="onTolak">
                <b-form-group label="Alasan Penolakan (Wajib Diisi)">
                    <b-form-textarea v-model="alasanTolak" name="alasanTolak" rows="3" maxlength="255" required />
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" :disabled="isSubmitting" @click="cancel()">Batal</b-button>
                <b-button variant="pgiBtn" :disabled="isSubmitting" type="submit" form="tolakDropOffForm">
                    <b-spinner small v-if="isSubmitting" />
                    {{ isSubmitting ? 'Memproses...' : 'Tolak' }}
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
    name: 'drop-off',
    computed: {
        canManagePacking() {
            return this.$helper.hasPermissionMenuChildren(CONSTANTS.PERMISSION.LELANG_PACKING)
        },
        SHIPMENT_STATUS() {
            return CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS
        },
    },
    data() {
        return {
            isBusy: true,
            isSubmitting: false,
            isMobile: false,

            input: {
                show: 10,
                filterTanggalMulai: null,
                filterTanggalAkhir: null,
                filterCabangTujuan: null,
                filterStatus: null,
            },
            cabangOptions: [],
            statusOption: [
                { id: CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS.PENGIRIMAN_KE_DROPOFF, name: 'Dalam Pengiriman' },
                { id: CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS.DITERIMA_DROPOFF, name: 'Diterima' },
            ],
            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],
            fieldsDesktop: [
                { key: "noPengiriman", label: "Dus / Food Container" },
                { key: "tanggal", label: "Tanggal" },
                { key: "metodePengiriman", label: "Pengiriman" },
                { key: "cabangPengirimNama", label: "Cabang Pengirim" },
                { key: "cabangTujuanNama", label: "Cabang Tujuan" },
                { key: "status", label: "Status" },
                { key: "aksi", label: "Aksi" },
            ],
            fieldsMobile: [
                { key: "detail", label: "Detail" },
                { key: "aksi", label: "Aksi" },
            ],

            dataDropOffAll: [],
            dataDropOff: [],
            currentPage: 1,
            perPage: 10,
            rows: 0,
            totalViewText: "",

            activeId: null,

            alasanTolak: "",
        }
    },
    methods: {
        init() {
            this.isBusy = true

            const params = {
                startDate: this.input.filterTanggalMulai || null,
                endDate: this.input.filterTanggalAkhir || null,
                cabangTujuanId: this.input.filterCabangTujuan ? this.input.filterCabangTujuan.id : null,
                status: this.input.filterStatus,
            }

            this.$axios.get('lelang-packing/drop-off-shipment', { params }).then(response => {
                this.dataDropOffAll = response.data
                    // Dus yang ditolak hilang dari list, bukan ditampilin dengan status Ditolak
                    .filter(item => item.status != CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS.DITOLAK_DROPOFF)
                    .map(item => ({
                        id: item.shipmentId,
                        tanggal: item.createdAt,
                        pengirimStaffNama: item.createdBy || '-',
                        cabangPengirimNama: item.cabangPengirim ? item.cabangPengirim.name : '-',
                        cabangTujuanNama: item.dropOffCabang ? item.dropOffCabang.name : '-',
                        deliveryChannelNama: item.deliveryChannel ? item.deliveryChannel.name : '-',
                        isCabangSendiri: !!item.cabangPengirim && !!item.dropOffCabang && item.cabangPengirim.id == item.dropOffCabang.id,
                        status: item.status,
                        duses: (item.boxes || []).map(box => ({
                            sourceDusId: box.boxId,
                            dusType: box.boxType ? box.boxType.name : '-',
                            jumlahBarang: (box.items || []).reduce((total, i) => total + i.count, 0),
                            rincianBarang: (box.items || []).map(i => `${i.jenisBarang.name} ${i.count}`).join(', '),
                        })),
                    }))
                this.currentPage = 1
                this.applyFilter()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => { this.isBusy = false })
        },

        applyFilter() {
            let filtered = this.dataDropOffAll

            this.rows = filtered.length
            this.perPage = this.input.show

            const start = (this.currentPage - 1) * this.perPage
            this.dataDropOff = filtered.slice(start, start + this.perPage)
            this.updateTotalViewText()
        },

        updateTotalViewText() {
            if (this.rows == 0) {
                this.totalViewText = "0 dari 0 data"
                return
            }

            const start = (this.currentPage - 1) * this.perPage + 1
            let end = (this.currentPage - 1) * this.perPage + this.perPage
            if (end > this.rows) end = this.rows
            this.totalViewText = "Menampilkan " + start + " - " + end + " dari " + this.rows + " entri"
        },

        onFilter() {
            this.currentPage = 1
            this.init()
        },

        onReset() {
            this.input.filterTanggalMulai = null
            this.input.filterTanggalAkhir = null
            const activeCabangId = this.$helper.getCabangId()
            this.input.filterCabangTujuan = this.cabangOptions.find(cabang => cabang.id == activeCabangId) || null
            this.input.filterStatus = null
            this.currentPage = 1
            this.init()
        },

        onLimitChange() {
            this.currentPage = 1
            this.applyFilter()
        },

        onPageChange() {
            this.applyFilter()
        },

        canTerima(item){
            return this.canManagePacking && item.status == this.SHIPMENT_STATUS.PENGIRIMAN_KE_DROPOFF
        },

        canTolak(item){
            return this.canManagePacking && item.status == this.SHIPMENT_STATUS.PENGIRIMAN_KE_DROPOFF
        },

        //----------------- Fungsi Terima -----------------

        openModalTerima(id) {
            this.activeId = id
            this.$bvModal.show('modal-confirm-terima-dropoff')
        },

        onTerima() {
            this.isSubmitting = true
            this.$axios.post(`lelang-packing/shipment/${this.activeId}/receive`).then(() => {
                this.$helper.toastSucc(this, "Dus berhasil diterima!")
                this.$bvModal.hide('modal-confirm-terima-dropoff')
                this.init()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => { this.isSubmitting = false })
        },

        //----------------- Fungsi Tolak -----------------

        openModalTolak(id) {
            this.activeId = id
            this.alasanTolak = ""
            this.$bvModal.show('modal-tolak-dropoff')
        },

        onTolak() {
            if (this.$helper.isNullOrEmpty(this.alasanTolak)) {
                return this.$helper.toastErr(this, "Mohon mengisi alasan penolakan!")
            }

            this.isSubmitting = true
            this.$axios.post(`lelang-packing/shipment/${this.activeId}/decline`, { note: this.alasanTolak }).then(() => {
                this.$helper.toastSucc(this, "Dus berhasil ditolak.")
                this.$bvModal.hide('modal-tolak-dropoff')
                this.init()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => { this.isSubmitting = false })
        },

        handleResize() {
            this.isMobile = window.innerWidth <= 576
        },
    },
    created() {
        this.cabangOptions = this.$helper.getAllCabang() || []

        const activeCabangId = this.$helper.getCabangId()
        this.input.filterCabangTujuan = this.cabangOptions.find(cabang => cabang.id == activeCabangId) || null

        this.init()
    },
    mounted() {
        this.handleResize()
        window.addEventListener("resize", this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize)
    },
}
</script>
